<div class="quote-note-control">
  <mat-form-field class="actions__textarea">
    <textarea 
      #reason
      [(ngModel)]="message"
      class="actions__textarea--input"
      [rows]="2"
      [maxLength]="255"
      [placeholder]="'Note'"
      matInput>
    </textarea>
    <mat-hint align="end">{{reason.value.length}} / 255</mat-hint>
  </mat-form-field>
</div>
